import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useRef } from "react";
import { useMutation } from "react-query";
import useDownloadState from "recoilStore/useDownloadState";
import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders, showMutationAlert } from "utils/helpers";

const useExportModeledUtilityData = (buildingModelUid: string) => {
    const alert = useAlert();
    const { setState } = useDownloadState();
    const accessToken = useAccessToken();
    const controller = useRef<AbortController>();

    return useMutation({
        mutationFn: async () => {
            controller.current = new AbortController();
            setState((prev) => ({
                ...prev,
                controller: controller.current,
            }));

            const res = await fetch(
                `${BACKEND_DOMAIN}/buildings/${buildingModelUid}/export-modeled-utility-data`,
                {
                    method: "GET",
                    headers: buildRequestHeaders(accessToken),
                    signal: controller.current.signal,
                }
            );
            if (!res.ok) throw new Error(`Error: status: ${res.status}`);
            const disposition = res.headers.get("Content-Disposition") ?? "";
            const match = disposition.match(/filename=([^;]+)/);
            const filename = match ? match[1] : "modeled_utility_data.csv";
            const blob = await res.blob();
            return { blob, filename };
        },
        onSuccess: ({ blob, filename }: { blob: Blob; filename: string }) => {
            setState((prev) => ({ ...prev, downloadComplete: true }));
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        },
        onError: (error) => {
            showMutationAlert(error, alert);
        },
    });
};

export default useExportModeledUtilityData;
